import { render, staticRenderFns } from "./TestCors.vue?vue&type=template&id=d141e268&scoped=true"
import script from "./TestCors.vue?vue&type=script&lang=js"
export * from "./TestCors.vue?vue&type=script&lang=js"
import style0 from "./TestCors.vue?vue&type=style&index=0&id=d141e268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d141e268",
  null
  
)

export default component.exports